import React from 'react';
import WrapperFormControl from 'components/atoms/WrapperFormControl';
import { FormControl, Input, InputLabel } from '@material-ui/core';

const FormControlInput = ({
    instruction,
    name,
    type,
    label,
    color,
    handleChange,
    handleBlur,
    value,
}) => {
    return (
        <WrapperFormControl instruction={instruction} name={name}>
            <FormControl fullWidth>
                <InputLabel htmlFor={name} color={color}>
                    {label}
                </InputLabel>
                <Input
                    id={name}
                    type={type}
                    color={color}
                    value={value}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    inp
                />
            </FormControl>
        </WrapperFormControl>
    );
};

export default FormControlInput;
